export default {
    // 権限管理
    User_username: 256,
    User_mail_address: 256,
    User_tel_number: 256,
    Permission_permissionName: 256,
    Permission_permissionMemo: 256,
    
    // 録音音声
    Call_Overview_Display: 20,

    // 通話分類管理
    Category_name: 10,
    Category_explanation: 100,

    // 固有名詞管理
    ProperNoun_ProperNounHints: 100,

    // 要約詳細管理
    PhoneBook: {
        name: 50,
        phone_number: 20,
        memo: 200
    },

    // VoCカテゴリ管理
    vocCategoryName: 128,
    vocCategoryPromptText: 2048,

    // パートナー管理
    partner_name: 128,
    partner_s3_bucket_name: 63,
    partner_domain: 128,
    partner_identifier: 128,
}
